<ng-content></ng-content>
@if (showError()) {
<div class="invalid-feedback text-danger primary-font-regular">
  {{ firstErrorMessage() | translate }}
</div>
}
